import React, {useEffect, useState} from 'react';

import { Row, Col, Space, Typography, Button } from 'antd';
// import { useTheme } from 'utils/Theme';
import SurveyInput from 'components/module/SurveyInput';

import { AnswerSurveyGeneratedProps } from './AnswerSurvey.props';
import {
  Container,
  StyledTitle,
  ButtonSpace,
  SectionTitle,
} from './AnswerSurvey.style';
import {AnswerSurveyType, QuestionCollection, Section, SurveyType} from 'models/Survey';
import {SubmittedFormType} from 'models/SubmittedForm';

const { Title } = Typography;


const toAnswers = (survey?: SurveyType) => (submittedForm?: SubmittedFormType) => {
  const answers: AnswerSurveyType = {};

  survey?.order?.forEach(key => {
    const questions = survey.sections[key].questions.map(({question, type }) => {
      let v = '';
      if (submittedForm && submittedForm?.answers && key in submittedForm?.answers) {
        v = submittedForm?.answers[key].questions.find(q => q.question === question)?.value || '';
      }
      return ({ question, type, value: v });
    });
    answers[key] = { questions };
  });
  return answers;
}

const AnswerSurveyView = (props: AnswerSurveyGeneratedProps): JSX.Element => {
  const { survey, submittedForm } = props;
  const [currentSection, setCurrentSection] = useState<string>('');
  const [answerForm, setAnswerForm] = useState<AnswerSurveyType>({});
  const [isSubmitting, setIsSubmitting] = useState<boolean>(false);

  useEffect(() => {
    setCurrentSection(survey?.order?.at(0) as string);
    setAnswerForm(toAnswers(survey)(submittedForm));
  }, [survey, submittedForm]);

  const getQuestions = (section: string) => {
    if (survey && survey?.sections) {
      const collection = survey?.sections[section];
      return collection ? collection.questions : [];
    }
    return [];
  };

  const getAnswer = (section: string, ndx: number) => {
    if (answerForm && answerForm[section]) {
      return answerForm[section].questions[ndx];
    }
    return { value: '' };
  };

  function onClickNext() {
    if (survey && currentSection != survey.order.at(-1)) {
      let idx = survey.order.findIndex(str => str === currentSection);

      setCurrentSection(survey.order[idx + 1]);
      window.scrollTo(0, 0);
    }
  }

  function onClickBack() {
    if (survey && currentSection !== survey?.order.at(0)) {
      let idx = survey.order.findIndex(str => str === currentSection);

      setCurrentSection(survey.order[idx - 1]);
      window.scrollTo(0, 0);
    }
  }

  function onChangeInput(value: string, key: string, question: string) {
    const newAnswerForm = { ...answerForm };

    const ndx = newAnswerForm[key].questions.findIndex(
      (q) => q.question === question
    );

    const newQuestions = [...newAnswerForm[key].questions];

    if (ndx === -1) {
      return;
    }

    newQuestions[ndx].value = value;
    newAnswerForm[key].questions = newQuestions;

    setAnswerForm(newAnswerForm);
  }

  function onClickSubmit() {
    setIsSubmitting(true);
    props.onSubmit(answerForm)
    .finally(() => {
      setIsSubmitting(false);
    });
  }

  return (
    <Container>
      <img
        src="https://trello-attachments.s3.amazonaws.com/602532c51bd99d8afa282e34/602fb4ade48e1525bb666ac7/d3553f450bbc503227eb898472d6b3b8/Pri_A_YB%404x-100.jpg"
        alt=""
        style={{ width: '300px', backgroundRepeat: 'no-repeat' }}
      />

      <Row justify="center">
        <Col span={20} sm={20} md={12}>
          {/* Titles */}
          <Space direction="vertical">
            <StyledTitle>{survey?.title}</StyledTitle>

            <SectionTitle level={2}>{currentSection}</SectionTitle>
          </Space>

          {/* Questions */}
          <Space direction="vertical" size={40}>
            { getQuestions(currentSection).filter((q) => q.question !== '')
              .map((question, ndx) => (
                <div key={currentSection + '' + ndx}>
                  <Title level={4}>
                    {ndx + 1}. {question.question}
                  </Title>

                  <SurveyInput
                    type={question.type}
                    onChange={(val: string) =>
                      onChangeInput(val, currentSection, question.question)
                    }
                    value={getAnswer(currentSection, ndx)?.value}
                  />
                </div>
              ))}
          </Space>

          {/* Buttons */}
          <ButtonSpace align="center">
            {(currentSection != survey?.order?.at(-1)) ? (
              <>
                <Button type="primary" size="large" onClick={onClickBack}>
                  Prev
                </Button>
                <Button type="primary" size="large" onClick={onClickNext}>
                  Next
                </Button>{' '}
              </>
            ) : (
              <Button
                type="primary"
                size="large"
                onClick={onClickSubmit}
                loading={isSubmitting}
              >
                Submit
              </Button>
            )}
          </ButtonSpace>
        </Col>
      </Row>
    </Container>
  );
};

export default AnswerSurveyView;
